import React from 'react';
import { CalendarDays, FileText, ChevronRight, Quote, Heart } from 'lucide-react';

const Tile = ({ icon: Icon, title, desc, onClick, testId, delay }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className="lv-card lv-lift an-rise w-full text-left p-3.5 flex items-center gap-3 group" style={{ animationDelay: `${delay}ms` }}>
    <span className="h-10 w-10 shrink-0 rounded-xl bg-gradient-to-br from-blue-50 to-violet-50 border border-blue-100/70 text-blue-600 flex items-center justify-center"><Icon className="h-5 w-5" strokeWidth={1.9} /></span>
    <span className="min-w-0 flex-1">
      <span className="block text-[14.5px] font-bold text-slate-900">{title}</span>
      <span className="block text-[12.5px] text-slate-500 leading-snug mt-0.5">{desc}</span>
    </span>
    <ChevronRight className="h-4 w-4 text-slate-400 group-hover:text-slate-700 group-hover:translate-x-0.5 transition-all" />
  </button>
);

// LEAVE-UI-001: secondary assistance panel — links to existing Calendar / Policies only (no new workflows).
export const LeaveAssistPanel = ({ onPlanBetter, onOpenPolicy }) => (
  <aside className="space-y-3" data-testid="leave-assist-panel">
    <Tile icon={CalendarDays} title="Plan Better" desc="Check your calendar and balance before applying for leave." onClick={onPlanBetter} testId="leave-assist-plan-better" delay={260} />
    <Tile icon={FileText} title="Leave Policy" desc="View company leave policy and guidelines." onClick={onOpenPolicy} testId="leave-assist-policy" delay={320} />
    <div className="an-rise rounded-2xl border border-violet-100 bg-gradient-to-br from-violet-50 via-indigo-50/70 to-white p-3.5 flex items-start gap-3" style={{ animationDelay: '380ms' }} data-testid="leave-assist-quote">
      <span className="h-9 w-9 shrink-0 rounded-full bg-violet-100 text-violet-600 flex items-center justify-center"><Quote className="h-4.5 w-4.5 fill-current" /></span>
      <p className="text-[14px] font-semibold text-violet-800 leading-snug pt-0.5">
        “A well-rested you,<br />is a stronger tomorrow.” <Heart className="inline h-4 w-4 -mt-1 text-violet-500" />
      </p>
    </div>
  </aside>
);

export default LeaveAssistPanel;
